import React, { PropTypes } from "react";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ReactTimeout from "react-timeout";
import classNames from "classnames";
import MessageBox from "./MessageBox";

import { BSModal } from "./";

class ArchiveButton extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = { showModal: false };

    this.close = this.close.bind(this);
    this.confirmOperation = this.confirmOperation.bind(this);
    this.confirmed = this.confirmed.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }

  confirmOperation() {
    this.setState({ showModal: true });
  }

  confirmed() {
    this.setState({ showModal: false });
    this.props.setTimeout(this.props.archiveFunction, 100);
  }

  render() {
    const actionLinkClasses = classNames({
      "dataTable-action-button": true,
      "action-icon": true,
      "icon-bin": true,
      disabled: this.props.disabled,
    });
    const titleKey = this.props.title
      ? this.props.title
      : this.props.isArchived
      ? "archiveButton.modal.title.unarchive"
      : "archiveButton.modal.title.archive";

    return (
      <span className="dataTable-action-button">
        {this.props.isButton ? (
          <Button
            ref="action"
            className="dataTable-action-button delete-button"
            bsStyle="danger"
            bsSize={this.props.bsSize}
            disabled={this.props.disabled}
            onClick={this.confirmOperation}
          >
            {this.props.buttonText || <FormattedMessage id="common.delete" />}
          </Button>
        ) : (
          <span
            ref="action"
            className={actionLinkClasses}
            onClick={!this.props.disabled && this.confirmOperation}
          >
            {this.props.label}
          </span>
        )}
        <BSModal
          show={this.state.showModal}
          title={
            <FormattedMessage id={titleKey}>
              {(f) => <span className="icon warning">{f}</span>}
            </FormattedMessage>
          }
          actions={[
            {
              id: 1,
              text: <FormattedMessage id="common.confirm" />,
              action: this.confirmed,
            },
          ]}
          onClose={this.close}
        >
          <div>
            {this.props.warningMessage && (
              <MessageBox className="alert-danger">
                {this.props.warningMessage}
              </MessageBox>
            )}
            {this.props.confirmationMessage ? (
              <FormattedMessage
                id={this.props.confirmationMessage}
                values={{ archivedName: this.props.archivedName }}
              />
            ) : this.props.isArchived ? (
              <FormattedMessage
                id="archiveButton.confirmationMessage.unarchive"
                values={{ archivedName: this.props.archivedName }}
              />
            ) : (
            <div>
            {(!this.props.isArchived && this.props.showDefaultDanger) && (
              <MessageBox className="alert-danger">
                <FormattedMessage id="archiveWarning"/>
              </MessageBox>    
              )}
              <FormattedMessage
                id="archiveButton.confirmationMessage.archive"
                values={{ archivedName: this.props.archivedName }}
              />
            </div>
            )}
          </div>
        </BSModal>
      </span>
    );
  }
}

ArchiveButton.propTypes = {
  archiveFunction: PropTypes.func.isRequired,
  archivedName: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.array.isRequired,
  ]),
  warningMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  bsSize: PropTypes.string,
  buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  confirmationMessage: PropTypes.string,
  disabled: PropTypes.bool,
  isArchived: PropTypes.bool,
  isButton: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  setTimeout: PropTypes.func,
  title: PropTypes.string,
  showDefaultDanger: PropTypes.bool
};

export default ReactTimeout(ArchiveButton);



// WEBPACK FOOTER //
// ./src/components/common/ArchiveButton.js